import DEFAULT_INVITE_CODE from './inviteCodes'

export const POST_APPROVAL_EXPERIENCE = {
  DEFAULT: 'default',
  APP_DOWNLOAD_V1: 'appDownloadV1',
} as const

export type PostApprovalExperience =
  (typeof POST_APPROVAL_EXPERIENCE)[keyof typeof POST_APPROVAL_EXPERIENCE]

export const APP_FORM_QUESTION_VARIANTS = {
  CONTROL: 'control',
  VARIANT_A: 'variantA',
  VARIANT_B: 'variantB',
  VARIANT_C: 'variantC',
  VARIANT_D: 'variantD',
  VARIANT_E: 'variantE',
  VARIANT_F: 'variantF',
  VARIANT_G: 'variantG',
  VARIANT_H: 'variantH',
} as const

export type AppFormQuestionVariant =
  (typeof APP_FORM_QUESTION_VARIANTS)[keyof typeof APP_FORM_QUESTION_VARIANTS]

export const CREDIT_PROTECTION_HEADER_VARIANTS = {
  CONTROL: 'control',
  VARIANT_A: 'variantA',
  VARIANT_B: 'variantB',
  VARIANT_C: 'variantC',
  VARIANT_D: 'variantD',
} as const

export type CreditProtectionHeaderVariant =
  (typeof CREDIT_PROTECTION_HEADER_VARIANTS)[keyof typeof CREDIT_PROTECTION_HEADER_VARIANTS]

export const AAN_OFFER_HANDOFF_VARIANTS = {
  CONTROL: 'control',
  VARIANT_A: 'variantA',
} as const

export type AanOfferHandoffVariant =
  (typeof AAN_OFFER_HANDOFF_VARIANTS)[keyof typeof AAN_OFFER_HANDOFF_VARIANTS]

export type FeatureFlagSet = {
  testFlag?: boolean
  defaultDirectTrafficInviteCode: string
  postApprovalExperience: PostApprovalExperience
  showPqOfferTerms: boolean
  appFormQuestionVariant: AppFormQuestionVariant
  creditProtectionHeaderVariant: CreditProtectionHeaderVariant
  aanOfferHandoffVariant: AanOfferHandoffVariant
}

const defaultFeatureFlagSet: FeatureFlagSet = {
  defaultDirectTrafficInviteCode: DEFAULT_INVITE_CODE,
  postApprovalExperience: POST_APPROVAL_EXPERIENCE.DEFAULT,
  showPqOfferTerms: false,
  appFormQuestionVariant: APP_FORM_QUESTION_VARIANTS.CONTROL,
  creditProtectionHeaderVariant: CREDIT_PROTECTION_HEADER_VARIANTS.CONTROL,
  aanOfferHandoffVariant: AAN_OFFER_HANDOFF_VARIANTS.CONTROL,
}

export default defaultFeatureFlagSet
